/**
 * Resolve a tool-provided path or URL into a navigation target.
 * - http(s) URLs are flagged external (open in a new tab).
 * - Internal paths get the App Router `[locale]` prefix if missing. The prefix
 *   check matches the whole segment, so `/development` is NOT treated as already
 *   locale-prefixed for locale `de`.
 */
export function resolveNavPath(
  target: string,
  locale: string
): { external: boolean; href: string } {
  const t = target.trim();
  if (/^https?:\/\//i.test(t)) return { external: true, href: t };

  const clean = t.startsWith("/") ? t : `/${t}`;
  const alreadyPrefixed =
    clean === `/${locale}` || clean.startsWith(`/${locale}/`);
  const href = alreadyPrefixed
    ? clean
    : `/${locale}${clean === "/" ? "" : clean}`;
  return { external: false, href };
}
